import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import React from 'react';
import { globalStyles } from './style/gstheme';

const styles = theme => {
    return Object.assign({
        icon: {
            color: theme.palette.text.disabled
        }
    }, globalStyles);
};

function CustomConnector(props) {
    return (
        <div>
            <KeyboardArrowRightIcon className={props.classes.icon} />
        </div>
    );
}

CustomConnector.propTypes = {
    classes: PropTypes.object
};

export default withStyles(styles)(CustomConnector);